import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';

import ReclamationsRetourPlateformeTableToolbar from './ReclamationsRetourPlateformeTableToolbar';
import ReclamationsRetourPlateformeTableHead from './ReclamationsRetourPlateformeTableHead';
import PackingListDialog from './PackingListDialog';
import PlateformeConfirmationDialog from './PlateformeConfirmationDialog';

import Utilisateur from 'components/Shared/Utilisateur';
import Client from 'components/Shared/Client';
import Datetime from 'components/Shared/Datetime';
import ArticleARisquePicto from 'components/Shared/ArticleARisquePicto';

// Exemple d'une réclamation :
//{
//    "id": 62496,
//    "numeroPiece": "F20010003253",
//    "numeroPreparation": "F20010003253",
//    "dateCreation": "2020-02-04T14:38:30.11117",
//    "client": {
//        "code": "67182",
//        "libelle": "DIVERS ANGLET"
//    },
//    "emetteur": {
//        "id": 531,
//        "nom": "Matthias DELARETTE",
//        "prenom": null,
//        "codePO": "DEL"
//    },
//    "type": {
//        "code": "CLIENT",
//         "libelle": "Client"
//    },
//    "categorie": {
//        "code": "DEMANDE_RETOUR_MARCHANDISE_LIVREE_CONFORME",
//        "libelle": "Retour volontaire"
//    },
//    "qualification": {
//        "code": "PLUS_USAGE",
//        "libelle": "Le client n'a plus l'usage de sa commande"
//    },
//    "depotDepart": {
//        "codeDepot": "00",
//        "nom": "WIP"
//    },
//    "surPaletteRetour": false
//},

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%'
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2)
  },
  table: {
    minWidth: 750
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1
  },
  myCell: {
    '& p': {
      margin: 0
    }
  },

  pagination: {
    marginBottom: theme.spacing(8)
  },
    
}));

export default function ReclamationsRetourPlateformeTable({
    reclamations,
    generatePackingList,
    isGeneratingPackingList,
    codeDepot,
    toggleSurPaletteRetour,
    onChangePlateformeCode,
    plateformeCode })

{

  let rows = reclamations.map(reclamation => {
    let row = {
      id: reclamation.id,
      dateCreation: reclamation.dateCreation,
      client: reclamation.client.code + ' - ' + reclamation.client.libelle,
      emetteur: reclamation.emetteur.codePO,
      depotDepart: reclamation.plateforme.code,
      numeroPreparation: reclamation.numeroPreparation,
      numeroPiece: reclamation.numeroPiece,
      type: reclamation.type.libelle,
      categorie: reclamation.categorie.libelle,
      qualification: reclamation.qualification.libelle,
      surPaletteRetour: reclamation.surPaletteRetour,

      // Les champs servent pour l'ordre de tri, par contre on garde la réclamation pour les affichages (à voir pour optimiser en ne gardant que le strict nécessaire)
      reclamation: reclamation
    };

    return row;
  });


    let selections = reclamations.map(reclamation => reclamation.id);

  const classes = useStyles();

  const [selected, setSelected] = React.useState(selections);

  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('id');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);

  const [packingListDialogOpen, setPackingListDialogOpen] = React.useState(false);
  const [plateformeConfirmationDialogOpen, setPlateformeConfirmationDialogOpen] = React.useState(false);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = event => {
    if (event.target.checked) {
      const newSelecteds = rows.map(n => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }

    setSelected(newSelected);
  };

  const handleClickSurPaletteRetour = (event, id) => {
      event.stopPropagation();
      toggleSurPaletteRetour(id);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleClickOpenPackingList = event => {
      //setPackingListDialogOpen(true);
      setPlateformeConfirmationDialogOpen(true);
  };

  const handleClickClosePackingList = event => {
    setPackingListDialogOpen(false);
  };

  const handleClickClosePlateformeConfirmation = event => {
      setPlateformeConfirmationDialogOpen(false);
  };

    const handleClickPlateformeConfirmation = event => {
        setPlateformeConfirmationDialogOpen(false);
        setPackingListDialogOpen(true);
    };

  const handleClickGeneratePackingList = innerParam => {
    //setPackingListDialogOpen(false);

    // On y ajouter les ids de réclamations séléctionnées
      let params = { ...innerParam, reclamationIds: selected, codeDepot, plateformeCode };

    // On génére la liste via l'api
    generatePackingList(params);
  };

  const isSelected = id => selected.indexOf(id) !== -1;

  return (
    <div className={classes.root}>


        <PlateformeConfirmationDialog
            open={plateformeConfirmationDialogOpen}
            onCancel={handleClickClosePlateformeConfirmation}
            onValid={handleClickPlateformeConfirmation}

            onChangePlateformeCode={onChangePlateformeCode}
            plateformeCode={plateformeCode}
        />

        <PackingListDialog
          open={packingListDialogOpen}
          onCancel={handleClickClosePackingList}
          onGenerate={handleClickGeneratePackingList}
          isGeneratingPackingList={isGeneratingPackingList}
        />

    <Paper className={classes.paper}>
      <ReclamationsRetourPlateformeTableToolbar
          numSelected={selected.length}
          onClickOpenPackingList={handleClickOpenPackingList}
      />
      <TableContainer>
        <Table className={classes.table} aria-labelledby="tableTitle" size={'medium'} aria-label="enhanced table">
          <ReclamationsRetourPlateformeTableHead
            classes={classes}
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            rowCount={rows.length}
          />
          <TableBody>
            {stableSort(rows, getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                const isItemSelected = isSelected(row.id);
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <TableRow
                    hover
                    onClick={event => handleClick(event, row.id)}
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.id}
                    selected={isItemSelected}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox checked={isItemSelected} inputProps={{ 'aria-labelledby': labelId }} />
                    </TableCell>
                    <TableCell component="th" id={labelId} scope="row" padding="none" align="left" sx={{ whiteSpace: 'nowrap' }}>
                      <span style={{ display: 'inline-block', textAlign: 'left' }}>{row.id}</span>
                      {row.reclamation.aRisque && <ArticleARisquePicto sx={{ ml: 0.5, verticalAlign: 'middle' }} />}
                    </TableCell>

                    <TableCell padding="checkbox">
                            <Checkbox checked={row.reclamation.surPaletteRetour} onClick={event => handleClickSurPaletteRetour(event, row.id)}/>
                    </TableCell>

                    <TableCell align="left">
                      <Datetime datetime={row.reclamation.dateCreation} shortYear={false} withTooltip />
                    </TableCell>
                    <TableCell className={classes.myCell} align="left">
                      <Client client={row.reclamation.client} format="code-libelle" withTooltip />
                    </TableCell>
                    <TableCell className={classes.myCell} align="left">
                      <Utilisateur utilisateur={row.reclamation.emetteur} format="court" />
                        </TableCell>
                    <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>{row.depotDepart}</TableCell>
                    <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>{row.numeroPreparation}</TableCell>
                    <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>{row.numeroPiece}</TableCell>
                    <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>{row.type}</TableCell>
                    <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>{row.categorie}</TableCell>
                    <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>{row.qualification}</TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        className={classes.pagination}
        rowsPerPageOptions={[20]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  </div>
  );
}
